import * as React from 'react';
export const konbiniMinistopSvg = React.forwardRef(
  function konbiniMinistopSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCC300',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm6 16.33 6.09-6.28.383.37h5.346c.44-.267.965-.42 1.516-.42a2.93 2.93 0 0 1 2.916 2.621 2.916 2.916 0 0 1 2.083 2.794c-.017.198.002.163-.05.55A2.487 2.487 0 0 1 26 18.33a2.494 2.494 0 0 1-2.183 2.48v2.518H8.233l-.041-6.965L6 16.331Z',
        fill: '#fff',
        stroke: '#fff',
        strokeWidth: 7,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm14.32 12.206-2.23-2.156L6 16.33l2.192.034.041 6.965h15.584v-2.518A2.494 2.494 0 0 0 26 18.33a2.487 2.487 0 0 0-1.716-2.366c.052-.387.033-.352.05-.55 0-1.32-.878-2.435-2.083-2.794A2.93 2.93 0 0 0 19.335 10c-.552 0-1.076.153-1.516.42',
        stroke: '#003894',
        strokeWidth: 3,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }),
    );
  },
);
konbiniMinistopSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var konbiniMinistop = {
  category: 'brand',
  colorable: false,
  name: 'konbiniMinistop',
  svg: konbiniMinistopSvg,
};
